import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../utils/axios";
import GroupNotificationForm from "./components/GroupNotificationForm";
import GroupMembersList from "./components/GroupMembersList";
import {
    Box,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Spinner,
    Heading,
    Input,
    Button,
    VStack,
    HStack,
    useToast,
    Text,
    Grid,
    GridItem,
} from "@chakra-ui/react";

const UserGroupDetails = () => {
    const { id } = useParams();
    const [userGroup, setUserGroup] = useState(null);
    const [loading, setLoading] = useState(true);
    const toast = useToast();

    useEffect(() => {
        const fetchUserGroupDetails = async () => {
            try {
                const response = await axiosInstance.post(
                    `/dummy/get-user-group-details`,
                    { h_usergroup_id: id }
                );
                toast({
                    title: response.message,
                    description: response.description,
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                });
                setUserGroup(response.data.data);

                console.log(Object.entries(response.data.data));
                console.log(response.data.data);
            } catch (error) {
                console.error("Error fetching user group:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchUserGroupDetails();
    }, [id]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = {
            month: "long",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        };
        return date.toLocaleDateString("en-US", options);
    };

    if (loading) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100vh"
            >
                <Spinner size="xl" />
            </Box>
        );
    }

    if (!userGroup) {
        return <Heading>User Group '{id}' not found</Heading>;
    }

    return (
        <Box p={4}>
            <Heading size="lg" mb={6}>Manage User Group</Heading>
            
            <Grid templateColumns="repeat(2, 1fr)" gap={8}>
                {/* Left Column - Basic Details */}
                <GridItem>
                    <VStack align="stretch" spacing={4}>
                        <Box>
                            <Text fontWeight="bold">Name</Text>
                            <Text>{userGroup.short_desc}</Text>
                        </Box>
                        <Box>
                            <Text fontWeight="bold">Type</Text>
                            <Text>{userGroup.group_type}</Text>
                        </Box>
                        <Box>
                            <Text fontWeight="bold">Created By</Text>
                            <Text>{userGroup.created_by}</Text>
                        </Box>
                        <Box>
                            <Text fontWeight="bold">Created On</Text>
                            <Text>{formatDate(userGroup.created_at)}</Text>
                        </Box>
                    </VStack>
                </GridItem>

                {/* Right Column - Member Counts */}
                <GridItem>
                    <VStack align="stretch" spacing={4}>
                        <Box>
                            <Text fontWeight="bold" color="red.500">Active</Text>
                            <Text fontSize="xl" color="red.500">{userGroup.active_members_count}</Text>
                        </Box>
                        <Box>
                            <Text fontWeight="bold" color="red.500">Not Active</Text>
                            <Text fontSize="xl" color="red.500">{userGroup.inactive_members_count}</Text>
                        </Box>
                        <Box>
                            <Text fontWeight="bold" color="red.500">Total Members</Text>
                            <Text fontSize="xl" color="red.500">{userGroup.total_members_count}</Text>
                        </Box>
                    </VStack>
                </GridItem>
            </Grid>
            
            <Box mt={8}>
                <GroupNotificationForm usergroupId={id} />
            </Box>

            <GroupMembersList usergroupId={id} />
        </Box>
    );
};

export default UserGroupDetails;
